import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ReusableCard = ({
  heading,
  data = [],
  link,
  linkText = "View All",
  loading = false,
  emptyMessage = "No data found",
  renderItem,
  className = ""
}) => {
  const navigate = useNavigate();

  const handleViewAllClick = (e) => {
    e.preventDefault();
    if (link) navigate(link);
  };

  return (
    <div className={`mb-3 ${className}`}>
      <Card className="h-100 shadow-sm dashboard-card">
        <Card.Header className="bg-white border-bottom">
          <div className="d-flex justify-content-between align-items-center py-2">
            <h5 className="mb-0 fw-bold text-dark">{heading}</h5>
            {/* If link is present and data is not empty, show the link */}
            {link && data.length > 0 && (
              <a
                href={link}
                className="icon-link icon-link-hover"
                style={{ "--bs-link-hover-color-rgb": "25, 135, 84" }}
                onClick={handleViewAllClick}>
                {linkText}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="bi"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <path d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                </svg>
              </a>
            )}
          </div>
        </Card.Header>
        <Card.Body className="px-2 pt-0 pb-2">
          {loading ? (
            <div className="p-3 text-center">
              <div className="spinner-border spinner-border-sm text-primary"
                role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : data.length > 0 ? (
            data.map((item, index) => renderItem(item, (index == data?.length - 1)))
          ) : (
            <div className="p-3 text-center text-muted">{emptyMessage}</div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ReusableCard;
